import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchConfig, submitWhatsAppLead, trackWhatsAppClick } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

const FALLBACK_WA = "601169406107";

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [waModal, setWaModal] = useState({ open: false, service: "General Inquiry", serviceKey: null, countryKey: null });

  useEffect(() => {
    fetchConfig().then(setConfig).catch(() => setConfig(null));
  }, []);

  const openWhatsApp = useCallback((opts = {}) => {
    setWaModal({ open: true, service: opts.service || "General Inquiry", serviceKey: opts.serviceKey || null, countryKey: opts.countryKey || null });
  }, []);
  const closeWhatsApp = useCallback(() => setWaModal((s) => ({ ...s, open: false })), []);

  const buildWaUrl = useCallback((number, service, page, leadId) => {
    const msg = `Hello Global Pass Consultants. I am interested in ${service}. I am contacting you from the ${page} page.${leadId ? ` My inquiry reference is ${leadId}.` : ""} Please contact me to know more.`;
    return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
  }, []);

  const defaultNumber = config?.defaultWhatsApp || FALLBACK_WA;

  const value = { config, defaultNumber, waModal, openWhatsApp, closeWhatsApp, buildWaUrl, submitWhatsAppLead, trackWhatsAppClick };
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}
